import Vue from 'vue';
import Component from 'vue-class-component';

@Component({
  props: {
    isLoading: Boolean,
  },
})
export default class LoadingMixin extends Vue {}



// WEBPACK FOOTER //
// ./src/mixins/LoadingMixin.js